
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '@/tool'
import { modelUtils } from '@/utils'
let { WizContainer } = framework_tool
let { WizForm, WizInput, WizRow, WizCol, WizButton, WizSelect, WizSpin } = component_tool

class Review extends WizContainer {
    componentName = 'Review'

    constructor(props) {
        super(props)
        let { record, rows } = props
        this.state = {
            batch: rows ? true : false,
            record,
            rows,
            remark: '',
            timestamp: new Date().getTime()
        }
    }

    propsAndStateOnChange = {
        appointmentReview: this._appointmentReview.bind(this)
    }

    _appointmentReview(nextProps, nextState) {
        let { success, msg } = nextProps.appointmentReview
        if (success) {
            if (nextProps.changeModal) {
                nextProps.changeModal(false, true)
            } else {
                wizNotice.success(msg || '审核成功')
            }
        } else {
            wizNotice.error(msg || '审核失败,请稍后再试')
        }
        return false
    }


    _recordColumns = (record = {}) => {
        return [
            {
                title: '场地名称',
                name: 'name',
                formItem: {
                    type: 'custom',
                    render: () => {
                        return <div>{record.name || ''}</div>
                    }
                }
            },
            {
                title: '场地编号',
                name: 'code',
                formItem: {
                    type: 'custom',
                    render: () => {
                        return <div>{record.code || ''}</div>
                    }
                }
            },
            {
                title: '预约日期',
                name: 'date',
                formItem: {
                    type: 'custom',
                    render: () => {
                        let { start, end } = record
                        let value = start + ' ~ ' + end
                        return <div>{value}</div>
                    }
                }
            },
            {
                title: '预约人',
                name: 'fullName',
                dataIndex: 'fullName',
                formItem: {
                    type: 'custom',
                    render: () => {
                        return <div>{record.fullName || ''}</div>
                    }
                }
            },
            {
                title: '联系电话',
                name: 'orderMobile',
                formItem: {
                    type: 'custom',
                    render: () => {
                        return <div>{record.orderMobile || ''}</div>
                    }
                }
            },
            {
                title: '审核备注',
                name: 'remark',
                formItem: {
                    type: 'custom',
                    render: () => {
                        return (
                            <>
                                <WizInput.TextArea
                                    placeholder='请输入审核意见'
                                    maxLength={100}
                                    autoSize={{ minRows: 3, maxRows: 3 }}
                                    onChange={(e) => this.setState({ remark: e.target.value })}
                                />
                                <div>{this.state.remark.length + '/100'}</div>
                            </>
                        )
                    }
                }
            }
        ]
    }

    _onClick = flag => {
        let { changeModal } = this.props
        let { batch, record, rows, remark } = this.state
        let ids = []
        if (batch) {
            rows && rows.length && rows.forEach(row => {
                ids.push(row.id)
            })
        } else {
            ids.push(record.id)
        }
        if (ids.length) {
            this.doAction({
                path: 'siteOrder/appointmentReview',
                payload: {
                    key: 'appointmentReview',
                    apiParams: {
                        ids,
                        remark,
                        status: flag ? 1 : 2
                    }
                }
            })
        } else {
            if (changeModal) {
                changeModal(false, true)
            }
        }
    }

    _renderFooter = () => {
        return (
            <WizRow className="form-btns row-item">
                <WizCol span={24}>
                    <WizButton title='通过' type='primary' onClick={() => this._onClick(true)}>通过</WizButton>
                    <WizButton title='失败' type='reset' onClick={() => this._onClick(false)}>失败</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    _render() {
        let { batch, record } = this.state
        if (batch) {
            return this._renderForm()
        } else {
            let columns = this._recordColumns(record)
            let formProps = {
                ref: 'form',
                columns,
                record: record || {},
                preview: false,
                footer: this._renderFooter(),
                formItemLayout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 17 }
                }
            }
            return <WizForm {...formProps} />
        }
    }

    _renderForm = () => {
        let value = []
        this.props.rows.forEach(row => {
            value.push(row.id)
        })
        let formProps = {
            columns: [],
            record: {},
            preview: false,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }
        return (
            <WizSpin spinning={this.props.siteOrderLoading}>
                <strong>{'当前已选中： '} <strong>{this.state.rows.length}</strong> {' 条预约申请'}</strong>
                <div style={{ marginTop: 20 }}>
                    <WizSelect
                        style={{ width: 700 }}
                        mode='multiple'
                        open={false}
                        defaultValue={value}
                        onChange={(value, option) => this._wizSelectOnChange(value, option)}
                    >
                        {this.props.rows.map((row, i) => {
                            let title = '场地名称:' + row.name + '     预约时间:' + row.start + ' ~ ' + row.end
                            return (
                                <WizSelect.Option key={row.id} value={row.id} title={title}>
                                    {title}
                                </WizSelect.Option>
                            )
                        })}
                    </WizSelect>
                </div>
                <WizInput.TextArea
                    placeholder='请输入审核意见'
                    maxLength={100}
                    style={{ marginTop: 20, width: 700 }}
                    autoSize={{ minRows: 4, maxRows: 4 }}
                    onChange={(e) => this.setState({ remark: e.target.value })}
                />
                <div style={{ marginTop: 5 }}>{this.state.remark.length + '/100'}</div>
                <WizForm {...formProps} />
            </WizSpin>
        )
    }

    _wizSelectOnChange = (value, option) => {
        let { rows } = this.state
        let nextRows = []
        rows.length && rows.forEach(row => {
            value.some(item => { return row.id === item }) && nextRows.push(row)
        })
        this.setState({ rows: nextRows, timestamp: new Date().getTime() })
    }
}

const mapStateToProps = (state, ownProps) => {
    let { siteOrder } = state
    const appointmentReview = modelUtils.getModelEntity(siteOrder, 'appointmentReview');
    const load = modelUtils.getLoadingState(state, 'siteOrder')
    return {
        appointmentReview,
        ...load
    }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(Review)
